import { trackEvent } from 'lib/ui-analytics';
import { createUserInteraction } from '../utils';

import { TRACKING_ACTION, TRACKING_INTERACTION } from '../Constants';

export const utagPagination = (total, currentPage, count, cruiseRecommendationId) => {
  const variables = { '{0}': currentPage + 1, '{1}': Math.ceil(total / count) };
  let extraParams = {};

  if (cruiseRecommendationId) {
    extraParams = {cruiseRecommendationId}
  }

  const interaction = createUserInteraction({
    eventType: TRACKING_ACTION.PAGINATION,
    interaction: count
      ? TRACKING_INTERACTION.PAGINATION_CLICK.replace(
          /\{0\}|\{1\}/g,
          item => variables[item],
        )
      : '',
    changeNameInteraction: true,
  }, extraParams);

  trackEvent(interaction);
};
